import { SvgIcon } from '@material-ui/core'

export default function HeadphonesIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 3.75C8.43559 3.75 5.75 6.2048 5.75 9V10.5123C5.83223 10.5042 5.91563 10.5 6 10.5H8C8.82843 10.5 9.5 11.1716 9.5 12V17C9.5 17.8284 8.82843 18.5 8 18.5H6C4.61929 18.5 3.5 17.3807 3.5 16V13C3.5 12.3007 3.78716 11.6684 4.25 11.2146V9C4.25 5.16778 7.83242 2.25 12 2.25C16.1676 2.25 19.75 5.16778 19.75 9V11.2146C20.2128 11.6684 20.5 12.3007 20.5 13V16C20.5 17.3807 19.3807 18.5 18 18.5H16C15.1716 18.5 14.5 17.8284 14.5 17V12C14.5 11.1716 15.1716 10.5 16 10.5H18C18.0844 10.5 18.1678 10.5042 18.25 10.5123V9C18.25 6.2048 15.5644 3.75 12 3.75Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
